import { useLocation, useNavigate } from "react-router-dom";
import GenericFormHeader from "../../components/dms_common/GenericFormHeader";
import "./createSaleReturnDetails.css"
import { useCallback, useEffect, useState } from "react";
import { DetailsBoxDivision, Invoice, SalesDetail } from "../../types/types";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { calculateReturnAmount, fetchSalesReturnData, getBatchDetailsFromDb, getSalesReturnReqBody, getAllProductDetailsFromDb } from "../SalesReturn/SalesReturnService";
import Header from "../../components/dms_common/Header";
import DetailsBox from "../../components/dms_common/DetailsBox";
import dayjs from "dayjs";
import { ChannelkartNetworkPost } from "../../services/networkService";
import { logLoadTrace } from "../../firebase";
import {navigateToSalesReturnDetails} from "../SalesReturn/SalesReturnUtils";
import MultiLevelTable from "../../components/multiLevelTable/multiLevelTable";
import { Box } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { getDataFromLocalDb } from "../../services/dbService";
import { Product } from "../createSecondaryOrder/models";
import { getMergedCatalogueAndRealTimeStockData } from "../stocks/RealTimeStock/RealTimeStockUtils";
import { validateReturnDetailsWithInvoice , fetchRestrictedSkuSet} from "../SalesReturn/SalesReturnService";
import { getConfigData } from "../../services/configurationService";


const CreateSaleReturnDetails = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [salesDetails, setSalesDetails] = useState<SalesDetail[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [detailsBoxDivisions, setDetailsBoxDivisions] = useState<DetailsBoxDivision[]>([]);
    const [returnEntries, setReturnEntries] = useState<any[]>([]);
    const [restrictedSkuSet, setRestrictedSkuSet] = useState<Set<string>>(new Set());
    const invoiceData: Invoice = location.state.invoiceDetails;
    const returnBatchDetails: any = location.state.returnBatchDetails || [];
    const [subTableRowIds, setSubTableRowIds] = useState<string[]>([]);
    const [isUnsellableReturnRestrictedEnable, setIsUnsellableReturnRestrictedEnable] = useState<boolean>(false);
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
    const isBatchIdConfiguration: boolean= ConfigDictionary?.batchIdConfiguration;
    
    
    if (!invoiceData) {
        navigate(-1);
    }

    const setDetailsBox = async()=>{
        const divisions:DetailsBoxDivision[] = [
            {
                components:[
                    {
                        label:"Return date",
                        value:dayjs().format("DD-MM-YYYY")
                    },
                    {
                        label:"Invoice No.",
                        value:invoiceData.invoiceSerialNumber || invoiceData.invoiceNumber
                    }
                ]
            },
            {
                components:[
                    {
                        label:"Outlet Code",
                        value:invoiceData.outletCode
                    },
                    {
                        label:"Outlet Name",
                        value:invoiceData.outletName
                    }
                ]
            },
            {
                components:[
                    {
                        label:"Account Type",
                        value:invoiceData.accountType 
                    }
                ]
            }
        ]
        setDetailsBoxDivisions(divisions);
    }

    const fetchAndUpdateSalesDetails = async () => {
      
        const batchDetails = await getBatchDetailsFromDb("salesReturnWithInvoice");
        batchDetails && invoiceData.salesDetails.forEach(salesDetails => {
            let caseQty = 0, pieceQty = 0, otherQty = 0;

            batchDetails[salesDetails.batchCode] && Object.keys(batchDetails[salesDetails.batchCode]).forEach(batchId => {
                batchDetails[salesDetails.batchCode][batchId].forEach(batch => {
                    caseQty += batch.caseQty;
                    pieceQty += batch.pieceQty;
                    otherQty += batch.otherQty;
                })
            })

            salesDetails.returnCaseQty = caseQty;
            salesDetails.returnPieceQty = pieceQty;
            salesDetails.returnOtherQty = otherQty;

            salesDetails.batchIds?.forEach(batchId => {
                batchId.reasonDetails = batchDetails?.[salesDetails.batchCode]?.[batchId.batchId];
            })

            salesDetails.netAmount = calculateReturnAmount(salesDetails);
        })

        const salesDetailMap = new Map();
        invoiceData.salesDetails.forEach((salesDetail) => {
            const key = salesDetail.batchCode;

            if (salesDetailMap.has(key)) {
                const existing = salesDetailMap.get(key);

                existing.pieceQuantity += salesDetail.pieceQuantity || 0;
                existing.otherUnitQuantity += salesDetail.otherUnitQuantity || 0;
                existing.caseQuantity += salesDetail.caseQuantity || 0;
                existing.initialPieceQuantity += salesDetail.initialPieceQuantity || 0;
                existing.initialCaseQuantity += salesDetail.initialCaseQuantity || 0;
                existing.initialOtherUnitQuantity += salesDetail.initialOtherUnitQuantity || 0;
                existing.normalizedQuantity += salesDetail.normalizedQuantity || 0;
                existing.initialNormalizedQuantity += salesDetail.initialNormalizedQuantity || 0;

                existing.soldCaseQty += salesDetail.soldCaseQty || 0;
                existing.soldOtherQty += salesDetail.soldOtherQty || 0;
                existing.soldPieceQty += salesDetail.soldPieceQty || 0;

                existing.totalCaseQty += salesDetail.totalCaseQty || 0;
                existing.totalOtherQty += salesDetail.totalOtherQty || 0;
                existing.totalPieceQty += salesDetail.totalPieceQty || 0;

                existing.initialAmount += salesDetail.initialAmount || 0;
                existing.billAmount += salesDetail.billAmount || 0;
                existing.netAmount += salesDetail.netAmount || 0;

                const newBatchIds = (salesDetail.batchIds || []).map(batchId => ({
                    ...batchId,
                    mrp: salesDetail.mrp,
                    price: salesDetail.price,
                    amount: salesDetail.netAmount,
                    returnedCaseQty: batchId.reasonDetails?.reduce((acc, reason) => acc + (reason.caseQty), 0) || 0,
                    returnedPieceQty: batchId.reasonDetails?.reduce((acc, reason) => acc + (reason.pieceQty), 0) || 0,
                    returnedOtherQty: batchId.reasonDetails?.reduce((acc, reason) => acc + (reason.otherQty), 0) || 0
                }));

                existing.batchIds = [...(existing.batchIds || []), ...newBatchIds];

                existing.batchIdCount = existing.batchIds.length;

            } else {
                const newEntry = {
                    ...salesDetail,
                    batchIds: [...(salesDetail.batchIds || []).map(batchId=>({
                        ...batchId,
                        mrp: salesDetail.mrp,
                        price: salesDetail.price,
                        amount: salesDetail.netAmount,
                        returnedCaseQty: batchId.reasonDetails?.reduce((acc, reason) => acc + (reason.caseQty), 0) || 0,
                        returnedPieceQty: batchId.reasonDetails?.reduce((acc, reason) => acc + (reason.pieceQty), 0) || 0,
                        returnedOtherQty: batchId.reasonDetails?.reduce((acc, reason) => acc + (reason.otherQty), 0) || 0
                    }))] 
                };
                salesDetailMap.set(key, newEntry);
            }
        });

        invoiceData.salesDetails = Array.from(salesDetailMap.values());

    await setDetailsBox();

    setSalesDetails(invoiceData.salesDetails);
}

    const handelReturnNumber = async () => {
        try {
            const response = await fetchSalesReturnData(undefined, undefined, undefined, returnBatchDetails.returnDetails);

            const filteredEntries = response.filter((obj: any) => obj.invoiceNumber === invoiceData.invoiceNumber);
            
            setReturnEntries(filteredEntries);

        } catch (e) {
            openPopup("Error", "Unable to fetch return details, please try again");
            console.log("Error fetching return details:", e);
            setReturnEntries([]);
        }
    };

    useEffect(()=>{
        logLoadTrace(fetchAndUpdateSalesDetails,"create_sale_returns_page_load_time");
    },[])

    useEffect(() => {
      const loadRestrictedSkus = async () => {
        try {
          const skuSet = await fetchRestrictedSkuSet();
          setRestrictedSkuSet(skuSet);
          const restrictedSkuConfig = await getConfigData(
                              "dms_configuration",
                              "restrictedSkuEnabled"
                            );
            const restrictedSku = restrictedSkuConfig[0]?.configValue ?? false;
          setIsUnsellableReturnRestrictedEnable(restrictedSku === true)
        } catch (e) {
          console.log("Failed to load restricted SKU set", e);
        }
      };
      loadRestrictedSkus();
    }, []);

    useEffect(() => {
        handelReturnNumber();
    }, []);

    const headerDetails = [
        {
            label:"Sale Return",
            redirectFunction: ()=>{navigate(-2)}
        },
        {
            label:"Create New Return",
            redirectFunction: ()=>{navigate(-1)}
        },
        {
            label:"Select SKUs"
        }
    ]

    const handleRedirect = async (rowData: SalesDetail) => {
        const productDetails = await getAllProductDetailsFromDb();
        if(!productDetails || !productDetails[rowData.batchCode]){
          openPopup("Error", "Product details not found");
          return;
        }
        const batchDetails = await getBatchDetailsFromDb("salesReturnWithInvoice");
        navigate("edit", {state:{
          rowData:rowData,
          productDetails:productDetails[rowData.batchCode],
          batchDetails:(batchDetails && batchDetails[rowData.batchCode]) ?? {},
          isRestrictedSku: isUnsellableReturnRestrictedEnable ? restrictedSkuSet.has(rowData.batchCode) : false,
        }});
      };

    const handleSearch = useCallback((searchStr: string) => {
        if(!searchStr){
            setSalesDetails(invoiceData?.salesDetails);
            return;
        }
        const filteredData = invoiceData?.salesDetails.filter(
            (salesDetail: SalesDetail) =>
                salesDetail.batchCode.toLowerCase().includes(searchStr.toLowerCase()) ||
                salesDetail.skuName.toLowerCase().includes(searchStr.toLowerCase()) ||
                salesDetail.packType.toLowerCase().includes(searchStr.toLowerCase())
        )
        setSalesDetails(filteredData);
    },[])

    const validateRequest = ()=>{
        if(!invoiceData.salesDetails.some(salesDetail=>salesDetail.returnCaseQty || salesDetail.returnOtherQty || salesDetail.returnPieceQty)){
            openPopup("Error", "Add quantity for atleast one sku to return!");
            throw new Error("empty returns");
        }
    }

    const handleCreateSalesReturnReview = async() => {
        
        if(isSubmitting){
            return;
        }
        validateRequest();
        setIsSubmitting(true);
        try {   
            const requestBody = getSalesReturnReqBody(invoiceData);

            if(requestBody.salesDetails.length == 0){
                openPopup("Error", "Add quantity for atleast one sku to return!");
                setIsSubmitting(false);
                return;
            }
            const validatedInvoiceDetails = await validateReturnDetailsWithInvoice(invoiceData);
             navigate("review", {
            state: {
                invoiceDetails: validatedInvoiceDetails,
                isReturnInvoice: true,
                reqBody: requestBody,
                submission: "createReturn"
            }
        });
        }catch(e){
            openPopup("Error", "Validation failed, please try again");
        }
        setIsSubmitting(false);
    }

    const getFooterElement = () => {
        return (
            <div className="sale-return-submit-button-container">
                <button
                    className={`sale-return-submit ${isSubmitting ? "disabled" : ""}`}
                    onClick={handleCreateSalesReturnReview}
                >
                    <span className="sale-return-submit-text">
                        Review Return
                    </span>
                </button>
            </div>
        )
    }

    useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
      event.preventDefault();
      if (!isSubmitting) {
        try {
          validateRequest();
          handleCreateSalesReturnReview();
        } catch (e) {
          // Error handled by validateRequest via openPopup
        }
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [isSubmitting, handleCreateSalesReturnReview, validateRequest]);

    const handleBatchIdClick = async (itemId: string) => {
        console.log('Clicked return entry ID:', itemId);
        try{
            const returnsRowData= returnEntries.find(item => item.id === itemId);
            await navigateToSalesReturnDetails( "view", returnsRowData,navigate, "Select SKUs");
        }catch(e){
            openPopup("Error", "Unable to view sale return details, please try again");
            console.log("Error navigating to sale return details:", e);
        }
    };

    const handleOpenSubTable = (rowId: string) => {
        if (subTableRowIds.includes(rowId)) {
            setSubTableRowIds(subTableRowIds.filter(id => id != rowId));
        } else {
            setSubTableRowIds([...subTableRowIds, rowId]);
        }
    }
    const isSubTableOpen = (rowId: string) => {
        return subTableRowIds.includes(rowId);
    }

    return (
        <div className="sale-return-details-container">

            <GenericFormHeader
                labelDetails={headerDetails}
                searchFunction={handleSearch}
            />
            <DetailsBox divisions={detailsBoxDivisions}/>
            <Header
                title={"Select products to add return quantity"}
            />
            {returnEntries.length > 0 && (
                <div className="returnBatchHyperLink">
                    For the selected invoice, {returnEntries.length} return entries have been recorded with the following Return IDs:{' '}
                    {returnEntries.map((item, index) => (
                        <span key={item.id || index}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleBatchIdClick(item.id); 
                                }}
                                style={{
                                    color: '#007bff',
                                    textDecoration: 'underline',
                                    cursor: 'pointer'
                                }}
                            >
                                {item.returnNumber || item.id}
                            </a>
                            {index < returnEntries.length - 1 && ', '}
                        </span>
                    ))}
                    .
                </div>
            )}
            {/* <CustomDataGrid
                rows={salesDetails}
                columnsMetaData={getSalesReturnDetailsColumnMetaData()}
                tableWidth={0.78}
                redirectUrl={"edit"}
                redirectUrlFunction={handleRedirect}
                footerElement={getFooterElement}
            /> */}
            <MultiLevelTable
                rowData={salesDetails}
                columnsMetaData={getViewSalesReturnDetailsColumnMetaData(handleOpenSubTable, isSubTableOpen, handleRedirect, isBatchIdConfiguration)}
                footerElement={getFooterElement}
                subTableRowIds={subTableRowIds}
                subTableMetaData={subTableMetaData}
            />
        </div>
    )
}


const getViewSalesReturnDetailsColumnMetaData = (handleOpenSubTable: (rowId: string) => void, isSubTableOpen: (rowId: string) => boolean, handleRedirect: (rowData: SalesDetail) => void, isBatchIdConfiguration: boolean) => {
    let metaData = [
        {
            headerName: "SKU Code",
            mappedValue: "batchCode",
            width: "13%",
        },
        {
            headerName: "SKU Name",
            mappedValue: "skuName",
            width: "18%",
        },
        {
            headerName: "Pack Type",
            mappedValue: "packType",
            width: "10%",
        },
        {
            headerName: "Batch Ids",
            mappedValue: "batchIdDetails",
            width: "14%",
            renderCell: (row: SalesDetail) => {
                return <Box
                className="batch-drowdown-container"
                onClick={() => handleOpenSubTable(row.id)}
                sx={{
                cursor: "pointer",
                marginLeft: "auto",
                marginRight: "auto",
                backgroundColor: "#F7F7F7",
                }}
            >
                <Box sx={{ color: isSubTableOpen(row.id) ? "#17B4A3" : "#909090", fontSize: "11px" }}>
                View all batch IDs
                </Box>
                <div
                className="icon-border-circle"
                style={{ borderColor: isSubTableOpen(row.id) ? "#17B4A3" : "#909090" }}
                >
                {isSubTableOpen(row.id) ? (
                    <KeyboardArrowUp
                    style={{
                        fontSize: "13px",
                        color: isSubTableOpen(row.id) ? "#17B4A3" : "#909090",
                    }}
                    />
                ) : (
                    <KeyboardArrowDown style={{ fontSize: "13px" }} />
                )}
                </div>
            </Box>
            }
        },
        {
            headerName: "PTR",
            mappedValue: "price",
            width: "8%",
            displayType: "amount"
        },
        {
            headerName: "Returnable Qty",
            mappedValue: "soldCaseQty,soldPieceQty,soldOtherQty",
            width: "12%",
            displayType: "quantity",
        },
        {
            headerName: "Return Qty",
            mappedValue: "returnCaseQty,returnPieceQty,returnOtherQty",
            width: "14%",
            displayType: "quantity",
            hasEditPenSvg: true,
            redirectFunction: handleRedirect
        }
        // {
        //     headerName: "Return Value",
        //     mappedValue: "netAmount",
        //     width: "10%",
        //     displayType: "amount"
        // },
    ]
    if(!isBatchIdConfiguration){
        metaData =  metaData.filter(column => column.headerName !== "Batch Ids");
        metaData.forEach(column => {
            const width = parseInt(column.width.replace("%", ""));
            column.width = `${width + 14/metaData.length}%`;
        })
    }else{
        metaData =  metaData.filter(column => column.headerName !== "PTR");
        metaData.forEach(column => {
            const width = parseInt(column.width.replace("%", ""));
            column.width = `${width + 8/metaData.length}%`;
        })
    }
    return metaData;
}

const subTableMetaData = {
    mappedValue: "batchIds",
    columns: [
        {
            headerName: "Batch Id",
            mappedValue: "batchId",
            width: "25%",
        },
        {
            headerName: "MRP",
            mappedValue: "mrp",
            displayType: "amount",
            width: "15%",
        },
        {
            headerName: "PTR",
            mappedValue: "price",
            width: "15%",
            displayType: "amount"
        },
        {
            headerName: "Returned Qty",
            mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
            displayType: "quantity",
            width: "25%",
        },
        {
            headerName: "Return Value",
            mappedValue: "amount",
            width: "10%",
            displayType: "amount"
        }
    ]
}

export default CreateSaleReturnDetails;